<mat-card class="place-card" layout="row"
fxFlex="0 1 calc(33.3% - 32px)"
    fxFlex.lt-md="0 1 calc(50% - 32px)"
    fxFlex.lt-sm="100%">
  <mat-card-header>
    <div mat-card-avatar class="place-header-image">
        <i class="fas fa-map-marked-alt"></i>
    </div>
    <mat-card-title>{{place.street}}</mat-card-title>
    <mat-card-subtitle>Place N°{{place.id}}</mat-card-subtitle>
  </mat-card-header>
  <mat-card-content >
    <div [ngSwitch]="place.type">
        <span *ngSwitchCase ="'PMR'" class="fa-stack fa-4x parking-Icon" [title]="place.type">
            <i class="fas fa-parking fa-stack-2x "></i>
            <i class="parking-type fa-stack-1x fas fa-wheelchair" style="color:white"></i>
        </span>
        <span *ngSwitchCase = "'Paying'" class="fa-stack fa-4x parking-Icon" [title]="place.type">
            <i class="fas fa-parking fa-stack-2x "></i>
            <i class="parking-type fa-stack-1x fas fa-euro-sign" style="color:white"></i>
        </span>
        <span *ngSwitchCase = "'Private'" class="fa-stack fa-4x parking-Icon" [title]="place.type">
            <i class="fas fa-parking fa-stack-2x "></i>
            <i class="parking-type fa-stack-1x fas fa-ban" style="color:red"></i>
        </span>
        <span *ngSwitchCase = "'Resident'" class="fa-stack fa-4x parking-Icon" [title]="place.type">
            <i class="fas fa-parking fa-stack-2x "></i>
            <i class="parking-type fa-stack-1x fas fa-home" style="color:white"></i>
        </span>
        <span *ngSwitchCase = "'Delivering'" class="fa-stack fa-4x parking-Icon" [title]="place.type">
            <i class="fas fa-parking fa-stack-2x "></i>
            <i class="parking-type fa-stack-1x fas fa-truck" style="color:white"></i>
        </span>
        <span *ngSwitchCase = "'Rescue'" class="fa-stack fa-4x parking-Icon" [title]="place.type">
            <i class="fas fa-parking fa-stack-2x "></i>
            <i class="parking-type fa-stack-1x fas fa-ambulance" style="color:white"></i>
        </span>
        <span *ngSwitchDefault class="fa-stack fa-4x parking-Icon" [title]="place.type">
            <i class="fas fa-parking fa-stack-2x "></i>
            <i class="parking-type fa-stack-1x fas fa-home" style="color:white"></i>
        </span>
    </div>
    <div [ngSwitch]="place.busy">
            <p *ngSwitchCase ="true">
                Place Occupée <span *ngIf="place.immatriculation" class="immatriculation">par :  {{place.immatriculation}}</span>
            </p>
            <p *ngSwitchDefault>
              Place Libre
            </p>
    </div>
  </mat-card-content>
  <mat-card-actions>
    <button mat-button [title]="'Editer les information'">
        <i class="fas fa-edit" ></i>
    </button>
    <button mat-button [title]="'Editer la configuration'">
        <i class="fas fa-cogs"></i>
    </button>
  </mat-card-actions>
</mat-card>
